module.exports = __webpack_public_path__ + "img/roodie-app_icon.d58f2412.svg";